import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject(error.response || 'Something went wrong')
);
// axiosInstance.interceptors.response.use(
//   (res) => res,
//   (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
// );

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

export const getFetcher = async (url, config) => {
  const res = await axiosInstance.get(url, { ...config });
  return res.data;
};
export const getFetcher1 = async (url, config) => {
  const res = await axiosInstance.get(url, { ...config });
  return res;
};

export const getFetcherPrams = async (url, data, params, config) => {
  const res = await axiosInstance.get(url, data, { params, ...config });
  return res.data;
};

export const getFetcherPrams2 = async (url, data, params, config) => {
  const res = await axiosInstance.get(url, data, { params, ...config, responseType: 'blob' });
  return res;
};

export const getFetcherPramspdf = async (url, params, config) => {
  const res = await axiosInstance.get(url, { params, ...config, responseType: 'blob' });
  return res;
};


export const postFetcher = async (url, data, config) => {
  const res = await axiosInstance.post(url, data, { ...config });
  return res.data;
};

export const putFetcher = async (url, data, config) => {
  const res = await axiosInstance.put(url, data, { ...config });
  return res.data;
};

export const deleteFetcher = async (url, config) => {
  const res = await axiosInstance.delete(url, { ...config });
  return res.data;
};

export const postPramsFetcher = async (url, data, params, config) => {
  const res = await axiosInstance.post(url, data, { params, ...config });
  return res.data;
};

export const postPramsFetcherNew = async (url, data, params, config) => {
  const res = await axiosInstance.post(url, data, { params, ...config });
  return { status: res.status, data: res.data };
};

export const postPramsFetcher1 = async (url, data, params, config) => {
  const res = await axiosInstance.post(url, data, { params, ...config });
  return res;
};
export const postPramsFetcher2 = async (url, data, params, config) => {
  const res = await axiosInstance.post(url, data, { params, ...config, responseType: 'blob' });
  return res;
};

export const postFetcher1 = async (url, data, config) => {
  const res = await axiosInstance.post(url, data, { ...config });
  return res;
};
export const postFetcher2 = async (url, data, config) => {
  const res = await axiosInstance.post(url, data, { ...config });
  return res.data;
};
export const postFetcher3 = async (url, config) => {
  const res = await axiosInstance.post(url, { ...config });
  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/auth/signin',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  cuttingMachine: {
    getAllCuttingMachine: 'v1/cuttingMachine'
  },
  cuttingout: {
    addCutting: '/cutting-out/save',
    getAllCutting: '/cutting-out',
    getActiveCuttingOut: '/cutting-out/getAllActive',
    getActiveCouttingOutBundleId: '/cutting-out/buyBundleId',
    getCuttingById: '/cutting-out/cutting_out',
    cuttingOutBundleSearch: '/cutting-out/bundle-search'
  },
  dashbordcarts: {
    lord: '/v1/total-sales/year',
    totalSalesss: '/v1/total-sales',
    activeCustomers: 'v1/customers/active-customers',
    customersReceivable: 'v1/pos/total-receivable',
    customersPayable: 'v1/pos/total-payable',
    posMonthlySale: 'v1/pos/monthly-sales-by-year',
    corporateCount: 'v1/corporate/corporate-count'
  },
  supplier: {
    add: '/v1/suppliers/supplier',
    getAllSuppliers: '/v1/suppliers/supplier',
    getSupplierById: '/v1/suppliers/supplier',
    getSupplierAddressById: '/v1/suppliers-address/addresses/address-search',
    poSearchbySupplierId: '/v1/purchase/order-search-id',
    PoSearchBySupplierIdAndPoNumberStatus5: '/v1/purchase/order-search-id-active',
    PoSearchBySupplierIdAndPoNumberStatusWise: '/v1/purchase/order-search-id',
    supplierUpdate: '/v1/suppliers/supplier',
    supplierReport: '/v1/suppliers/report',
    supplierPDFGenarator: '/v1/suppliers/report-pdf',
    supplierSearch: '/v1/suppliers/supplier-search',
    supplierSearch1: '/v1/suppliers/search'
  },
  materialMaster: {
    createMaterialMaster: '/v1/items/all',
    searchMaster: '/v1/items/item-search',
    materialMasterList: '/v1/items/all',
    materialMasterGetbyId: '/v1/items',
    materialRepo: '/v1/items/report',
    materialReportpdf: '/v1/items/report-pdf',
    materialReportDateFilter: '/v1/items/report',
    priceUpdateItemWise: '/v1/items/price-update-item',
    categoryWiseSearch: '/v1/items/category-wise-search',
    priceHistoryList: '/v1/price-history'
  },
  systemSettings: {
    productFeildList: '/v1/material-master/fields',
    systemMasterList: '/v1/items/all/0/10',
    systemMasterSearchList: '/v1/items/item-search',
    defineFiscalyear: '/v1/fiscal-year',
    getAllFiscalyear: '/v1/fiscal-year',
    definePeriod: '/v1/period-def',
    getAllPeriod: '/v1/period-def',
    getbyid: '/v1/fiscal-year',
    getbyid1: '/v1/period-def',
    updateFiscalyear: '/v1/fiscal-year',
    updatePeriodDefinition: '/v1/period-def',
    getSystemSettingFiscalyear: '/v1/system_settings/fiscal-year',
    addFiscalyeartoSystemSetting: '/v1/system_settings/fiscal-year',
    getAllFiscalYearPeriod: '/v1/period-def/fiscal-year-period'
  },
  systemMaster: {
    create: '/v1/items/item',
    update: '/v1/items/item',
    valuesCreate: '/v1/item-values/values',
    valuesEdit: '/v1/item-values/values',

  },
  purchaseOrder: {
    createPurchaseOrder: '/v1/purchase/order',
    getAllPurchaseOrder: '/v1/purchase/order',
    getById: '/v1/purchase/order-id',
    poSearchByPodateRange: '/v1/purchase/order-date-filter',
    poReport: '/v1/purchase/report',
    poReportPdf: '/v1/purchase/report-pdf',
    approve: '/v1/purchase/approve',

  },

  servicePurchaseOrder: {
    createServicePO: '/v1/service-purchase',
    getAllServicePO: '/v1/service-purchase/service-order',
    getById: '/v1/service-purchase/service-order-id',
    servicePOSearchByPodateRange: '/v1/service-purchase/service-order-date-filter',
    servicePOReport: '/v1/service-purchase/report',
    servicePOReportPDF: '/v1/service-purchase/report-pdf',
    approve: '/v1/service-purchase/approve',
  },

  goodReceiptnote: {
    createGoodReceiptNote: '/v1/good-receipts/receipt',
    grnSearchBySupplierId: '/v1/good-receipts/receipt',
    getAllGoodReceiptNote: '/v1/good-receipts/receipt',
    getById: '/v1/good-receipts/receipt',
    goodReceptDateFilter: '/v1/good-receipts/date-filter',
    goodReceptDataReport: '/v1/good-receipts/report',
    getCurrencyById: 'v1/currency/get-by-id',
    goodReceptPDFCreation: '/v1/good-receipts/report-pdf',
  },
  companyAddressController: {
    createCompanyAddress: '/v1/company-address/address',
    companyAddress: '/v1/company-address/address',
  },
  invoice: {
    createInvoice: '/v1/invoices/invoice',
    getAllInvoice: '/v1/invoices/invoice',
    getById: 'v1/invoices/invoice',
    invoiceFilterbyDate: 'v1/invoices/date-filter',
    invoiceReport: 'v1/invoices/receipt',

    invoiceListReport: 'v1/invoices/report',
    invoiceListReportPdf: 'v1/invoices/report-pdf',
    invoiceSearch: 'v1/invoices/invoice',
    costUpdateInvoiceSearch: 'v1/invoices',
    invoiceSearchController: 'v1/invoices',
    pendingCostupdateFilter: 'v1/cost-update/custom-search-paginated',
    finalCostupdateFilter: 'v1/cost-update/custom-search-paginated-with-finalized',
    invoiceSearchSupplierwise: 'v1/invoices/supplier-wise-search'
  },
  paymentType: {
    createPaymentType: '/v1/payments',
    getAllPaymentType: '/v1/payments/payment',
    createPaymentTerms: '/v1/payment-terms',
    getPaymentTerms: '/v1/payment-terms',
  },
  incoterms: {
    createIncoterms: '/v1/incoterms',
    getAllIncoterms: '/v1/incoterms',
  },
  deliveryCondition: {
    createDeliveryCondition: '/v1/delivery-conditions',
    getAlldeliveryCondition: '/v1/delivery-conditions',
  },
  deliveryTerms: {
    createDeliveryTerms: '/v1/delivery-terms',
    getAlldeliveryTerms: '/v1/delivery-terms',
  },
  priceManagement: {
    createPricing: '/v1/price',
    getAllPricing: '/v1/price',
  },
  systemUser: {
    createAdminUser: '/auth/signup',
    getSystemUser: '/v1/user',
    getUserRole: '/v1/user/roles',
    addLocation: '/v1/user/location',
    getUserbyid: '/v1/user',
    searchSystemUser: '/v1/hr-user-fetch/search-erp',
    searchSysttemUserByName: 'v1/hr-user-fetch/search',
    searchByUserEmpId: 'v1/hr-user-fetch/emp-search',
    searchByEmpID: 'v1/hr-user-fetch/emp-search-production',
    serchnewemployeeid: 'v1/hr-user-fetch/emp-search-by-empId',
    getratewithManualEntry: 'v1/manual-entry/getRateByentryTypeIdAndDate',
    createManualEntry: 'v1/manual-entry/AddManualEntry'

  }, embIn: {
    addEmbIn: 'emb-in/save',
    getEmbByBundleId: 'emb-in/buyBundleId',
    getAllActiveEmbIn: 'emb-in/getAllActive',
    embInBundleSearch: 'emb-in/bundle-search',
    getEmbById: 'emb-in/emb_in',

  }, qcIn: {
    addQcIn: 'qc-in/save',
    getQCId: 'qc-in/qc-in',
    getAllActiveQCIn: 'qc-in/getAllActive',
    qcInInBundleSearch: 'qc-in/bundle-search',
    getQcByBundleSearch: 'qc-in/buyBundleId',

  },
  streamIron: {
    addStreamIron: 'Steam-iron/save',
    getStreamIronId: 'Steam-iron/iron-in',
    getAllActiveStreamIron: 'Steam-iron/getAllActive',
    StreamIronInBundleSearch: 'Steam-iron/bundle-search',
    getStreamIronByBundleSearch: 'Steam-iron/buyBundleId',

  },
  HeavyIron: {
    addHeavyIron: 'v1/heavy-iron/save',
    getHeavyIronId: 'v1/heavy-iron/heavy_iron',
    getAllActiveHeavyIron: 'v1/heavy-iron/getAllActive',
    HeavyIronInBundleSearch: 'v1/heavy-iron/bundle-search',
    getHeavyIronBundleSearch: 'v1/heavy-iron/buyBundleId',
    getHeavyBundeleSearch: 'v1/heavy-iron/bundle-search'

  },
  valueAddtion: {
    addValueAditon: 'value-addition/save',

    getAllValueAdition: 'value-addition/getAllActive',
    valueAddtionBundleSearch: 'value-addition/bundle-search',
    valueAdditonGetByBudleID: 'value-addition/buyBundleId',
    valueBundleIdGet: 'value-addition/buyBundleId',
    getValueAddById: 'value-addition/value-addition',
    valueAdditionFundaRate: 'value-addtion-piece-rate/saveValueAddtionFundaWithRate',
    valueAdditionFundaRateGetAll: 'value-addtion-piece-rate/getAllFundaPatiRate',
    valueAdditionFundaRateUpdate: 'value-addtion-piece-rate/UpdateDeactivateFundaPati',
  },
  sideIn: {
    addSideIn: 'side-in/save',
    getSideIn: 'value-addition/getAllActive',
    sideInBundleSearch: 'side-in/bundle-search',
    sideInGetByBudleID: 'value-addition/buyBundleId',
    getAllSideIn: 'side-in/getAllActive',
    sideInBundleIdGet: 'side-in/buyBundleId',
    getSideInById: 'side-in/side-in'
  },
  embOut: {
    addEmbOut: 'emb-out/save',
    getEmbOutByBundleId: 'emb-out/buyBundleId',
    getAllActiveEmbOut: 'emb-out/getAllActive',
    embOutBundleSearch: 'emb-out/bundle-search',
    getEmbById: 'emb-out/emb_in',
  },
  galaIn: {
    addGalaIn: 'galaIn/save',
    gellGalaIn: 'galaIn',
    getGalaInById: 'galaIn/gala_in',
    getGalaInBundleId: 'galaIn/buyBundleId',
    getAllGalaIn: 'galaIn/getAll_by_bundle',
    getAllActive: 'galaIn/getAllActive',
    getGalaInBundleSearch: 'galaIn/bundle-search'
  },
  downfalliron: {
    addDownFallIron: 'v1/downfall-iron/save',
    gellDownFallIron: 'galaIn',
    getDownFallIronById: 'v1/downfall-iron/downfall-iron',
    getDownFallIronId: 'v1/downfall-iron/buyBundleId',
    getAllDownFallIronIn: 'galaIn/getAll_by_bundle',
    getAllDownFallIronActive: 'v1/downfall-iron/getAllActive',
    getDownFallIronInBundleSearch: 'v1/downfall-iron/bundle-search'
  },
  ironIn: {
    addIronIn: 'iron-in/save',
    gellGalaIn: 'galaIn',
    getIronInById: 'iron-in/iron-in',
    getGalaInBundleId: 'galaIn/buyBundleId',
    getAllGalaIn: 'galaIn/getAll_by_bundle',
    getAllActive: 'iron-in/getAllActive',
    getIronInBundleSearch: 'iron-in/bundle-search'
  }, packingOut: {
    addPackingOut: 'v1/packing-out/save',
    gellPaackingOut: 'galaIn',
    // getParckingOut: 'galaIn/gala_in',
    getPacikngOutId: 'v1/packing-out/buyBundleId',
    getPackingOut: 'galaIn/getAll_by_bundle',
    getPackingOutActive: 'v1/packing-out/getAllActive',
    getPackingOutSearch: 'packing-out/bundle-search',
    getPackingOutById: 'v1/packing-out/iron-in',
    packingOutPosIdSeacrh: 'v1/packing-out/pos-id-search'
  },
  customerCreation: {
    createCustomer: '/v1/customers',
    searchCustomerByMobile: '/v1/customers/search',
  },
  createLocation: {
    createBranchLocation: '/v1/location',
    getAllLocation: '/v1/location',
    getLocationById: '/v1/location',
    addUserLocation: '/v1/user/location',
  },
  pos: {
    checkInCheckOut: 'v1/pos-check-in',
    searchByBarCode: '/v1/pos/barcode',
    PosReceivableTableToolbarReportExcel: '/v1/pos/receivable/report',
    PosReceivableTableToolbarReportPDF: '/v1/pos/sales-report-pdf',
    posReceivableReport: '/v1/pos/pendingAndMobileAndInvoiceReport',
    posReceivableReportss: '/v1/pos/sales-report-pdf',
    receivedAndMobileAndInvoiceReport: '/v1/pos/receivedAndMobileAndInvoiceReport',
    receivedAndMobileAndInvoiceReports: '/v1/pos/sales-report-received-pdf',
    commonPieceRateFilterwithInvoiceAndBundlename: '/v1/prodcutionBundle/searchInvoiceAndBundleName',
    getAllEmployees: 'v1/user/roles',
    peaceRateFilterReport: 'v1/production-piece-rate/pieceRate/report',
    peaceRtaeSummeryFilterReport: 'v1/prodcutionReports/departmentSummery/report',
    employeewisesummeryReport: 'v1/prodcutionReports/employee-wise-production-summery/report',
    SearchByItemId: '/v1/pos/id',
    posCheckout: '/v1/pos/checkout',
    posCompleted: '/v1/pos/completed',
    mobileFilter: 'v1/pos/completedByMobile',
    addCart: '/v1/cart',
    getCart: '/v1/cart',
    getByUser: '/v1/cart/user',
    deleteCart: '/v1/cart',
    stockBatchwise: '/v1/batch',
    voidCart: '/v1/cart',
    posHistory: '/v1/pos/sales',
    posHistoryall: '/v1/pos/sales-all',
    putItemLinedataANDreturnquantity: '/v1/pos-return/return-amount',
    getReturnPriceCreaditNote: '/v1/pos-return',
    GetPurchaseHistoryAllFilterMobile: '/v1/pos/sales-all-mobile',
    getPurchaseHistoryInvoiceSearch: '/v1/pos/sales-all-mobile-with-invoice',
    GetPurchaseDiscountAllFilterMobile: '/v1/pos/sales-all-mobile-discount',
    GetPurchesingHistoryByBillNumber: '/v1/pos/search-by-bill-id',
    posReturnbill: '/v1/pos/bill',
    posReturnbillall: '/v1/pos-return/all',
    posBillReyurnHistory: '/v1/pos-return',
    itemSearchByname: '/v1/pos/name',
    SearchByNameReturnBarcode: '/v1/pos/item-name',
    SearchByBillId: '/v1/pos/search-by-bill-id',
    // invoice load with stiching and without stiching
    SearchByBillIdPendingMeasurement: '/v1/pos/pending-measurement/search-by-bill-id',
    SearchByBillIdPendingMeasurementNew: '/v1/pos/pending-measurement-lines-without-stitching-charges/search-by-bill-id',
    SearchByBillIdPendingMeasurementNewGetall: '/v1/pos/pending-measurement-lines-without-stitching-charges-get-all',
    SerchBrachwisesalesHistoryInvoice: '/v1/pos/get-invoice-numbers',
    BundleserchforCommonpiecerate: '/v1/prodcutionBundle',
    searchByBillIdPendingMeasurementNewGeteport: '/v1/pos/pending-measurement-lines-without-stitching-charges-report',
    searchByBillIdPendingMeasurementNewGeteportPDF: '/v1/pos/pending-measurement-lines-without-stitching-charges-report-pdf',
    GetReportBill: "/v1/pos/report",
    GetReportBillOriginal: "/v1/pos/report-original",
    GetReportBillPDF: "/v1/pos/report-pdf",
    GetPdfReportBill: '/v1/pos/sales-report-pdf',
    posDiscountHistory: 'v1/pos/discount-report',
    posDiscountHistoryPdf: '/v1/pos/discount-report-pdf',
    getReceivableByMobile: 'v1/pos/pendingByMobile',
    getAllReceable: "/v1/pos/pending",
    allfilterPoosReciveble: "v1/pos/pendingAndMobileAndInvoice",
    allfilterPoesRecived: "v1/pos/receivedAndMobileAndInvoice",
    commonPeaceRateFilter: "v1/production-piece-rate/pieceRateFilter",
    productionDetailsFilter: "v1/prodcutionReports/department/report",
    sectionwisedetailsreport: "v1/prodcutionReports/date-wise-production-summery/report",
    departmentwisewipreports: "v1/prodcutionReports/departmentWiseWipDetailReport/report",
    departmentwisesummeryreports: "v1/prodcutionReports/departmentWiseWipDetailReportAllSummery/report",
    getBillbyid: "/v1/pos/bill",
    posPaymentSettlement: '/v1/pos-payment',
    completedByInvoice: 'v1/pos/completedByInvoice',
    posReceivable: 'v1/pos/receivable/report',
    posReceived: 'v1/pos/received/report',
    getPosReturnAll: 'v1/pos-return/all',
    getPosReturnAllSearch: 'v1/pos-return/all-search',
    getPosReturnDateFilter: 'v1/pos-return/date-filter',
    posReturnSearch: 'v1/pos-return/search',
    posReturnReport: "v1/pos-return/excel-report",
    posReturnReportPdf: "v1/pos-return/pdf-report",
    posReturngetbyid: 'v1/pos-return/getById',
  },
  posPayment: {
    getCollectionData: 'v1/pos-payment/report',
    getCollectionDataRangeDetails: 'v1/pos-payment/report-new-date-range',
    getCollectionDataRange: 'v1/pos-payment/report-date-range',
    getCollectionDataSummery: 'v1/pos-payment/summery',
    daterangeCashCollectionPDF: '/v1/pos-payment/report-date-range-pdf',
  },
  vatinout: {
    vatIn: 'v1/account-transaction/vat-in',
    vatOut: 'v1/account-transaction/vat-out',

  },
  report: {
    getHeaderList: '/v1/stock/header',
    getBatchList: '/v1/stock/batch',
    ItemWiseMovement: '/v1/stock/item-wise-movement',
    getDetailsStockReport: '/v1/stock/stock-date-wise',
    getDetailsStockPDFReport: '/v1/report/detailed-stock-report-with-value-pdf',
    agingStockReport: '/v1/stock/stock-aging-report',
    agingStockReportPdf: '/v1/stock/stock-aging-report-pdf',
    allStockMovementReport: '/v1/stock/all-stock-movement',
    allStockMovementReportPdf: '/v1/stock/all-stock-movement-pdf',

    ItemWiseStockMovement: '/v1/stock/movement-excel',
    ItemWiseStockMovementDetail: '/v1/stock/movement-excel-detail',

  },
  salesOrder: {
    createSalesOrder: '/v1/so',
    getAllSalesOrder: '/v1/so',
    getByid: '/v1/so',
    changePickingStatus: '/v1/so/packing',
    getAllPickingList: '/v1/so',
    changeDeliveryStatus: '/v1/so/delivery',
    getStatuswiseSalesOrder: 'v1/so/status-wise',
    getSalesOrderalltheStatus: 'v1/so/status',
    accountReceivable: 'v1/so/account-receivable',
    accountPayble: 'v1/payable',
    accountPayblePending: 'v1/payable/pending',
    customerOutstanding: 'v1/so/customer/balance',
    payableStatement: 'v1/invoice-payment',
  },
  price: {
    createPrice: '/v1/price',
    getAllPrice: '/v1/price',
    priceListCreate: '/v1/prices',
    getAvailableAndInitialQty: '/v1/batch',
    getAllPriceList: '/v1/prices',
    priceAssign: '/v1/price-assign',
    priceAssignList: '/v1/price-assign',
    soPriceListAssign: '/v1/price-assign/so-item-search',
    priceAssignSearchBy: '/v1/prices/search-by-Item',
  },
  outBoundDelivery: {
    getAllPendingOutBound: '/v1/so',
  },
  paymennt: {
    getAllPayment: '/v1/payment',
    paymentSettle: '/v1/payment-line',
    postDatedChequeDetails: '/v1/payment-line/pending-cheque',
    chequeStatusChange: '/v1/payment-line/payment-status-change',
    getPaymentByid: '/v1/payable-line',
    supplierPaybleLine: '/v1/payable-line',
    getPaymentmethodbyid: 'v1/payable-line/method',
    paybleLineStatus: 'v1/payable-line/status',
  },
  defineCreditLimit: {
    createCreditLimit: '/v1/credit-limit',
    getAllCreditLimit: 'v1/credit-limit',
  },
  internalTransfer: {
    createInternalTransfer: '/v1/internal-transfer',
    transedStockList: '/v1/internal-transfer/send',
    stockListBatchwise: '/v1/batch',
    getByid: '/v1/internal-transfer/view',
    approveInternal: '/v1/internal-transfer',
    stockTransferGetbyiid: '/v2/internal-transfer',
    stockReportBranchwise: '/v1/batch',
  },
  internalTransferv2: {
    Add: "/v2/internal-transfer",
    SearchWithoutBranch: "/v2/internal-transfer/search",
    SearchWithBranch: "/v2/internal-transfer/search-branch-wise",
    GetById: "/v2/internal-transfer",
    Approve: "/v2/internal-transfer/approve",
    stockTransferExcel: "/v2/internal-transfer/date-rang-filter",
    stockTransferPdf: "/v2/internal-transfer/date-rang-filter-pdf",
  },
  stockAdjutment: {
    Add: "/v1/stock-adjustment",
    Adjustmentrestore: '/v1/adjustment-restore',
    GetStockAdjustment: "/v1/stock-adjustment",
    StockAdjustmentReport: "/v1/stock-adjustment/report",
    stockAdjustmentGetbyid: '/v1/stock-adjustment',
    approved: "/v1/stock-adjustment/approve",
  },
  additionalStock: {
    getAdditionalStockType: '/v1/Additional-Stock-Type',
    AddAdditionalStockType: '/v1/Additional-Stock-Type',
    AddAdditionalStockgetByid: '/v1/Additional-Stock-Type',
    addLocationType: '/v1/Additional-Stock-Type-Location',
    add: '/v1/additional-stock-issue'
  },
  location: {
    locationgetByid: '/v1/location',
  },
  cashDetails: {
    cashPayable: '/v1/payable-line/method',
    cashReceiable: '/v1/payment-line',
  },
  category: {
    categoryCreate: '/v1/category',
    categoryLevelSearch: '/v1/category/search-by-category',
    categoryLevel3Search: '/v1/category/search-category-level3',
    categoryLevel2Search: '/v1/category/find-category-level1',
  },
  finance: {
    main: '/v1/finance/main',
    subCategory1: '/v1/finance/subCategory1',
    subCategory2: '/v1/finance/subCategory2',
    subCategory3: '/v1/finance/subCategory3',
    subCategory4: '/v1/finance/subCategory4',
    getChartofaccounts: '/v1/finance/view',
    accountType: '/v1/finance-line',
    accountTypeList: '/v1/finance-line',
    accountTypeListJournal: 'journal/v1/finance-line',
    // accounts
    findAccounts: '/v1/finance-line/find',
    findAccountsLeveltwo: '/v1/finance-line/find',
    findExpenses: '/v1/finance-line/expenses',
    cashTransaction: '/v1/cash-bank',
    expenseTransaction: '/v1/cash-bank/expenses',
    transactionCredit: '/v1/bill',
    transactionCreditExpenses: '/v1/bill/expenses',
    createVat: 'v1/vat',
    getVat: 'v1/vat',
    getallVat: 'v1/vat',
    searchAllAcc: 'v1/finance-line',
    SearchPettyCash: 'v1/finance-line/petty-cash',
    SearchAll: 'v1/finance-line/search-all',
    searchAlldepartment: 'v1/hr-department-fetch',
    searchAllemployee: 'v1/hr-user-fetch/search',
    pettyCashPaymentList: 'v1/cash-bank/view',
    paymentGetbyid: 'v1/cash-bank/view',
    pettyCashReport: 'v1/cash-bank/cash-bank',
    pettyCashReportPdf: 'v1/cash-bank/cash-bank-pdf',
    pettyCashRegisterReport: 'v1/cash-bank/petty-cash-register',
    pettyCashRegisterReportPdf: 'v1/cash-bank/petty-cash-register-pdf',
    pettyCashDateFilter: 'v1/cash-bank/report',
    genaralLedger: 'v1/cash-bank/petty-cash-journal',
    pettyCashFloat: 'v1/petty-cash-definition',
    pettyCashFloatList: 'v1/petty-cash-definition',
    journalview: 'v1/account-transaction',
    journalviewwithPagination: '/api/v1/account-transaction/with-pagination',
    getViewSearch: 'v1/cash-bank/view-search',
    journalViewFilter: 'v1/account-transaction/with-pagination',
    journalViewFilterExcelExport: 'v1/account-transaction/journal-excel',
    cashRecept: 'v1/payment-receipt',
    cashReceiptList: 'v1/payment-receipt',
    SearchByDate: 'v1/payment-receipt/search-by-date',
    cashReceiptSearch: 'v1/payment-receipt/search',
    cashgetByid: 'v1/payment-receipt',
    cashReceiptReport: 'v1/payment-receipt/generate-report',
    cashReceiptReportPdf: 'v1/payment-receipt/generate-report-pdf',
    journalAccSearch: 'v1/finance-line/search',
    getReportForDetails: 'v1/finance-line/report',
    getReportForDetailsPdf: '/v1/finance-line/report-pdf',
    cashAndBankReceiptCommon: 'v1/common-receipt',
    cashAndBankReceiptGetbyid: 'v1/common-receipt',
    cashAndBankReceiptGetAll: 'v1/common-receipt',

    itemGroupWiseSalesReport: 'v1/report/sales-group',
    itemGroupWiseSalesReportPDF: '/v1/report/sales-group-pdf',
    itemGroupWiseSalesReportView: 'v1/report/sales-group-view',
    // wrong api address for sales report
    itemGroupWiseSalesReportViewNew: 'v1/report/item-group-wise-stock-view',

    customerWiseSalesReport: 'v1/report/customer-wise-sales-report',
    customerWiseSalesReportView: 'v1/report/customer-wise-sales-report-view',

    itemWiseSalesReport: 'v1/report/item-wise-sales-report',
    itemWiseSalesPDFReport: '/v1/report/item-wise-sales-report-pdf',
    // withoutPagination
    itemWiseSalesReportView: 'v1/report/item-wise-sales-report-view',
    itemWiseSalesReportViewNew: 'v1/report/item-wise-sales-report-view',

    locationWiseStockReport: 'v1/report/location-wise-stock-report',
    locationWiseStockReportPDF: '/v1/report/location-wise-stock-report-pdf',
    locationWiseStockReportView: 'v1/report/location-wise-stock-report-View',

    itemGroupwiseStockReport: 'v1/report/item-group-wise-stock-report',
    itemGroupwiseStockReportPDF: '/v1/report/item-group-wise-stock-report-pdf',
    // item group wise stock report
    itemGroupwiseStockReportView: 'v1/report/item-group-wise-stock-view',
    itemGroupwiseStockReportViewNew: 'v1/report/item-group-wise-stock-branch-view',

    // locationwiseDetailsStockReport: 'v1/report/stock',
    locationwiseDetailsStockReport: 'v1/report/location-wise-detail-stock-report',
    locationwiseDetailsStockReportView: 'v1/report/location-wise-detail-stock-report-view',
    locationwiseDetailsStockReportPDF: '/v1/report/details-stock-pdf',

    detailsStockReport: 'v1/report/detailed-stock-report-with-value',
    detailsStockReportView: 'v1/report/detailed-stock-report-with-value-view',

    dailyCollectionReport: 'v1/report/daily-collection',
    dailyCollectionReportView: 'v1/report/daily-collection-view',
    getTrialBalance: 'v1/account-transaction/trail-balance',
    getTrialBalanceView: 'v1/account-transaction/trail-balance-view',
    cashCollectionPDF: '/v1/pos-payment/report-pdf',
    dailyCollectionReportPdf: '/v1/report/daily-collection-summary-pdf',

    salesSummeryReport: 'v1/report/sales-summery-branch-wise',
    salesSummeryReportPDF: '/v1/report/sales-summery-branch-wise-pdf',
    salesSummeryReportView: 'v1/report/sales-summery-branch-wise-view',

    posReport: 'v1/pos/report',

    locationwiseDetailsSalesSummary: 'v1/report/location-wise-detail-sales-report_summery',
    locationwiseDetailsSalesSummaryNew: 'v1/report/location-wise-detail-sales-report_summery-new',
    locationwiseDetailsSalesSummaryNewPDF: '/v1/report/location-wise-detail-sales-report_summery-new-pdf',
    locationwiseDetailsStockSummary: 'v1/report/location-wise-detail-stock-report',
    // Location wise Details Sales Summary View 
    locationwiseDetailsSalesSummaryView: 'v1/report/location-wise-detail-sales-report_summery-view',

    finConfig: 'v1/acc-group-report-type',
    finConfigUpdate: 'v1/acc-group-report-type',
    finConfigList: 'v1/acc-group-report-type',
    finConfigbyId: 'v1/acc-group-report-type',
    // finConfigUpdate: 'v1/acc-group',

    setpnltoSystemSetting: 'v1/system_settings/set-pnl',
    setBStoSystemSetting: 'v1/system_settings/set-balance-sheet-group-type',

    addAccGroup: 'v1/acc-group',
    getAllGroup: 'v1/acc-group',
    finGroupConfigbyId: 'v1/acc-group',
    finGroupConfigUpdate: 'v1/acc-group',
    finGroupLineUpdate: 'v1/acc-group/line-update',
    finGroupOparation: 'v1/acc-group/operations',
    lineGetbyid: 'v1/acc-group/line',
    lineGetAll: 'v1/acc-group/line-list',

    journalEntry: 'v1/journal-manual-entry',
    journalEntryList: 'v1/journal-manual-entry',
    journalEntryListSearch:'v1/journal-manual-entry/journalManualEntrySearch',
    journalEntryGetbyid: 'v1/journal-manual-entry',
    journalEntryExcel: 'v1/journal-manual-entry/excel-report',
    journalEntrypdf: 'v1/journal-manual-entry/pdf-report',

    genaratePnl: 'v1/acc-pnl',
    genarateBS: 'v1/acc-balance-sheet'
  },
  measurements: {
    lengthTypes: 'v1/pos-len-style',
    nTypes: 'v1/pos-n',
    shTypes: 'v1/pos-sh',
    slTypes: 'v1/pos-sl',
    swTypes: 'v1/pos-sw',
    wTypes: 'v1/pos-w',
    fpTypes: 'v1/pos-fp',
    dwTypes: 'v1/pos-dw',
    kallyTypes: 'v1/pos-kally',
    styles: 'v1/pos-style',
    fit: 'v1/pos-fit',
    relations: 'v1/pos-relation',
    pocketTypes: 'v1/pos-pocket',
    dfTypes: 'v1/pos-df-types',
    sSeamTypes: 'v1/pos-sseam',
    buttonTypes: 'v1/pos-button',
    loop: 'v1/pos-loop',
    fpOepnTypes: 'v1/pos-w',
    pTypes: 'v1/pos-w',
    addNewData: "v1/measurement",
    updateData: 'v1/measurement',
    // getAllMeasurements: "v1/measurement",
    getAllMeasurements: "v1/measurement",
    getMeasurementId: "v1/measurement",
    getMeasurementOriginalId: "v1/measurement/original",
    getMeasurementOriginalEdit: "v1/measurement/original-edit",
    getMeasurement: "v1/measurement",
    getMeasurementForTrail: "v1/measurement/stock-issue",
    measurementWith: "v1/measurement/filtered_measurement",
    shCutTypes: "v1/pos-sh-cut",
    fundaLength: "v1/pos-funda",
    fundaTypes: "v1/fund-type",
    darizBack: "v1/dariz-back",
    darizFront: "v1/dariz-front",
    darizHalf: "v1/dariz-half",
    darizNeck: "v1/dariz-neck",
    darizNeckStyle: "v1/dariz-neck-style",
    darizSleeve: "v1/dariz-sleeve",
    darizType: "v1/dariz-type",
    darizDesignType: "v1/dariz-design-type",
    measurementLengthUpdate: 'v1/measurement/length-update',
    measurmentPrint: "v1/measurement/print",
    measuredBy: "v1/hr-user-fetch/measurement-user-search",
    getPossBill: "v1/pos/bill",
    stockIssuringPrint: 'v1/measurement/print-new',

    trialConfirmationList: 'v1/measurement/measurement-confirm-list',
    newtrialConfirmationList: 'v1/measurement/measurement-confirm-list',
    trialConfirm: 'v1/measurement/measurement-confirm',

    stockIssuingList: 'v1/measurement/stock-issue',

    searchBranchUser: '/v1/hr-user-fetch/branch-wise',

    measurementPrintCount: 'v1/measurement/print',
    measurementAnalysis: 'v1/measurement/measurement-analysis',
    measurementSearchbyinvoice: 'v1/measurement/search-mobile-invoice',
    searchMobileInvoice: '/v1/measurement/search-mobile-invoice',

  },
  manufacturing: {
    capacity: 'v1/manufacturer-capacity/get',
    capacityAdd: 'v1/manufacturer-capacity',
    manufacturingConfig: 'v1/measurement-config',
    manufacturingCapacityCheck: 'v1/manufacturer-capacity/check',
    createPlant: 'v1/plant',
    updatePlant: 'v1/plant',
    searchPlant: 'v1/plant/search',
    getAllPlant: 'v1/plant/plant',
    getbyidplant: 'v1/plant/plant',
    productionCategory: 'v1/production-category',
    updateproductionCategory: 'v1/production-category',
    getbyidproductionCategory: 'v1/production-category',
    searchproductionCategory: 'v1/production-category/search',
    getAllproductionCategory: 'v1/production-category',
    createOverhead: 'v1/bom-overheads/add',
    updateoverhead: 'v1/bom-overheads/update',
    searchOverhead: 'v1/overhead',
    createWorkCenter: 'v1/work-centers',
    getAllWorkCenters: 'v1/work-centers',
    workCenterGetbyid: 'v1/work-centers',
    updateWorkCenter: 'v1/work-centers',
    createbomGenaral: 'v1/bom-generals',
    updatebomGenaral: 'v1/bom-generals',
    materialcreate: 'v1/bom-materials',
    materialUpdate: 'v1/bom-materials',
    overheadcreate: 'v1/overhead/overhead',
    creaditNoteadd: 'v1/pos-return',
    overheadUpdate: 'v1/overhead',
    overheadGetById: 'v1/bom-materials',
    productionOderCreate: 'v1/production-header',
    getbyidOverhead: 'v1/overhead',
    getAllOverhead: 'v1/overhead',
    productionHeadergetAll: 'v1/production-header/get',
    bomGenaralGetbyId: 'v1/bom-generals',
    bomMaterialGetbyId: 'v1/bom-materials',
    getAllbomForTable: 'v1/bom-generals',
    getAllbomGeneral: 'v1/bom-generals',
    getAllbomMaterial: 'v1/bom-materials',
    bomGetbyid: 'v1/bom-generals',
    createBomOverhead: 'v1/bom-overheads',
    getbyIdBomOverhead: 'v1/bom-overheads',
    updateBomOverhead: 'v1/bom-overheads',
    getAllOverheadNamesBomOverhead: 'v1/overhead/overhead-names',
    getAllBomOverhead: 'v1/bom-overheads',
    productionOderGetbyid: 'v1/production-header/get',
    productionOrderLine: 'v1/production-line',
    productionOrderLinGetbyId: 'v1/production-line',
    productionOrderMethod: 'v1/generated-method',
    productionOrderMethodgetAll: 'v1/generated-method/get',
    productionOrderLinegetAll: 'v1/production-line/get',
    productionOrderMethodgetwithoutPagination: 'v1/generated-method/get'
  },
  unitOfMeasurement: {
    createUom: 'v1/unit-of-measurement',
    getUom: 'v1/unit-of-measurement'
  },
  numberingSystem: {
    createNumberingSystem: 'v1/numbering-system',
    getAllNumberingSystem: 'v1/numbering-system/get',
    updateNumberingSystem: 'v1/numbering-system/get',
    createType: 'v1/system-types',
    createTypeGetall: 'v1/system-types/getAll'
    // getUom: 'v1/unit-of-measurement'
  },
  costCenters: {
    createCC: 'v1/cost-center',
    getCostCenter: 'v1/cost-center',
    costCenterSearch: 'v1/cost-center'
  },
  subAccounts: {
    createSubAcc: 'v1/sub-account-category',
    subAccountCategoryAll: 'v1/sub-account-category',
    subAccAllwithPagination: 'v1/sub-account-category',
    subAccountsSearch: 'v1/sub-account/search'
    // getCostCenter: 'v1/cost-center',
    // costCenterSearch: 'v1/cost-center'
  },
  subAcc: {
    SubAcc: 'v1/sub-account',
    subAccAll: 'v1/sub-account',
    subAccSearch: 'v1/sub-account/search'
    // getCostCenter: 'v1/cost-center',
    // costCenterSearch: 'v1/cost-center'
  },
  honorific: {
    createHonorific: 'v1/person-definition',
    getHonorific: 'v1/person-definition/enable'
  },
  cashRegisterOpenAndClose: {
    getRegisterStatus: 'v1/cash-register',
    getRegisterOpen: 'v1/cash-register'
  },
  stockAjustment: {
    addStockAdjustment: 'v1/stock-adjusment'
  },
  measurementMaster: {
    createDesignNo: 'v1/pos-design-no',
    createRelation: 'v1/pos-relation',
    getRelation: 'v1/pos-relation',
    createFit: 'v1/pos-fit',
    getFit: 'v1/pos-fit',
    createSSEAM: 'v1/pos-sseam',
    getSSEAM: 'v1/pos-sseam',
    CreateFUNDALength: 'v1/pos-funda',
    getFUNDALength: 'v1/pos-funda',
    CreateBUTNType: 'v1/pos-button',
    getBUTNType: 'v1/pos-button',
    CreateLOOP: 'v1/pos-loop',
    getLOOP: 'v1/pos-loop',
    CreateBack: 'v1/dariz-back',
    getBack: 'v1/dariz-back',
    CreateNeckStyle: 'v1/dariz-neck-style',
    getNeckStyle: 'v1/dariz-neck-style',
    CreateHalf: 'v1/dariz-half',
    getHalf: 'v1/dariz-half',
    designNumberSearch: 'v1/pos-design-no/search',
    getDesignNumber: 'v1/pos-design-no',
    createStyle: 'v1/pos-style',
    getStyle: 'v1/pos-style',
    createShCut: "v1/pos-sh-cut",
    getShCut: 'v1/pos-sh-cut',
    createPocketType: 'v1/pos-pocket',
    getPocketType: 'v1/pos-pocket',
    createFUNDA: 'v1/pos-funda',
    createFundaType: 'v1/fund-type',
    getFundaType: 'v1/fund-type',
    getFUNDA: 'v1/pos-funda',
    createDFType: 'v1/pos-df-types',
    getDFType: 'v1/pos-df-types',
    createSHType: 'v1/pos-sh',
    getSHType: 'v1/pos-sh',
    createKALLY: "v1/pos-kally",
    getKALLY: 'v1/pos-kally',
    createDarizFront: 'v1/dariz-front',
    getDarizFront: 'v1/dariz-front',
    createDarizNeck: 'v1/dariz-neck',
    getDarizNeck: 'v1/dariz-neck',
    createDarizSleeve: 'v1/dariz-sleeve',
    getDarizSleeve: 'v1/dariz-sleeve',
    createDarizType: 'v1/dariz-type',
    getDarizType: 'v1/dariz-type',
    measurementReport: 'v1/measurement/report',
    measurementStockIssuedReport: 'v1/measurement/stock-issued-report',
    measurementStockIssuedPdf: '/v1/measurement/stock-issued-report-pdf',
    measurementTrialConfirmedReport: 'v1/measurement/trial-confirm-report',
    measurementTrialConfirmedReportPdf: '/v1/measurement/trial-confirm-report-pdf',
    measurementStockIssuingReport: 'v1/measurement/pending-stock-issued-report',
    measurementByPosID: 'v1/measurement/measurementBuyPosID'
  },

  production: {
    // bundle creation
    getInvoice: 'v1/measurement',
    getInoviceSeacrhByName: 'v1/measurement/search-by-invoice',
    searchByProduction: 'v1/prodcutionBundle/item_list',
    searchByProductionNew: 'v1/prodcutionBundle/item_list-by-measurement',
    getItems: 'v1/measurement',
    createBundle: 'v1/measurement',
    updateBundle: 'v1/measurement',
    saveProductionBundle: 'v1/prodcutionBundle/save-item-list',
    getProductionBundels: 'v1/prodcutionBundle',
    productionSavedBundles: 'v1/prodcutionBundle/all_item_list',
    productionSavedBundlesNew: 'v1/prodcutionBundle/buyPosID',
    productionBundleGetAll: 'v1/prodcutionBundle',
    productionBundleGetById: 'v1/prodcutionBundle/productuin_bundle',
    productionBundleNameSerach: 'v1/prodcutionBundle/bundle-search',
    productionBundleCreataionDeatils: 'v1/prodcutionBundle/bundle-creation-details',
    productionBundleSummeryDetails: 'v1/prodcutionBundle/bundle-summery-details',
    productionBundleGetAllBundleTrackingDetails: 'v1/prodcutionBundle/getAllBundleTrackingDetails',
    productionBundleGetAllActiveTransferList: 'v1/prodcutionBundleTransfer/getAllActive',
    productionBundleTransferSearch: 'v1/prodcutionBundleTransfer/search',
    productionBundleTransferId: 'v1/prodcutionBundleTransfer/prodcutionBundleTransfer',
    productionBundleTransferBundleSummeryDeatails: 'v1/prodcutionBundleTransfer/bundle-summery-details',
    productionBundleTransferLocation: 'v1/prodcutionBundleTransfer/locationId',
    productionBundleReceiveDeliveryNote: 'v1/prodcutionBundleReceive/getAllActive',
    productionBundleReceiveDeveryNoteSearch: 'v1/prodcutionBundleReceive/deliveryNote-search',
    prodcutionBundleReceivereportpdf: "v1/prodcutionBundleReceive/report-pdf",

  },
  cutterMachineController: {
    saveMaterialRate: "v1/cuttingMachine/saveMaterialRate",
    getAllSaveMatrialRate: 'v1/cuttingMachine/getAllMaterialRate',
    deactivateMaterialRate: 'v1/cuttingMachine/UpdateDeactivate',
  },
  cutterMachineDetailsController: {
    saveMachineRateRate: "cutter-machine-details/save",
    getAllSaveMachinelRate: 'cutter-machine-details/getAllMachineEmployees',
    deactivateMachineRate: 'cutter-machine-details/UpdateDeactivateEmployee',

  }, galaInMaterialRate: {
    galaInMaterialRateCreate: "gala-in-piece-rate/savePosStyleWithRate",
    getGalaInMaterialRate: "gala-in-piece-rate/getAllMaterialRate",
    deactivateGalaInMaterialRate: 'gala-in-piece-rate/UpdateDeactivateMaterialRate',

  }, galaInFundaRate: {
    galaInFundaRateCreate: 'gala-in-piece-rate/saveFundaWithRate',
    galaInFundaRateList: 'gala-in-piece-rate/getAllFundaRate',
    deactivateGalaInFundaRate: 'gala-in-piece-rate/UpdateDeactivateFundaRate',

  }, valueAdditionPiceRate: {
    valueAdditionPiceRateGalaInFront: 'value-addtion-piece-rate/saveFrontWithRate',
    valueAdditionPiceRateCommonDarizHalf: 'value-addtion-piece-rate/saveDarizRate',
    getAllValueAdditionPiceRateCoomonDarizHalf: 'value-addtion-piece-rate/getAllDarizRate'
  },

  valueAdditionGalaEmbRate: {
    createRate: 'value-addtion-piece-rate/saveFrontWithRate',
    getAllRate: 'value-addtion-piece-rate/getAllFrontWithRate',
    getById: 'value-addtion-piece-rate/getFrontWithRate',
    deactivateRate: 'value-addtion-piece-rate/UpdateDeactivateFrontWithRate'
  },


  valueAdditionCommonRate: {
    createRate: 'value-addtion-piece-rate/saveDarizRate',
    getAllRate: 'value-addtion-piece-rate/getAllDarizRate',
    getById: 'value-addtion-piece-rate/getDarizRate',
    deactivateRate: 'value-addtion-piece-rate/UpdateDeactivateDarizRate'
  },




  valueAdditionDesignRate: {
    createRate: 'value-addtion-piece-rate/saveValueAddtionDesignNoWithRate',
    getAllRate: 'value-addtion-piece-rate/getAllDesignNoRate',
    getById: 'value-addtion-piece-rate/getdesignNo',
    deactivateRate: 'value-addtion-piece-rate/UpdateDeactivateDesignNoRate'
  },

  sideInPieceRate: {

    sideInPieceRateCreate: "value-side-in-piece-rate/savePosStyleWithRate",
    getAllSideInPieceRate: "value-side-in-piece-rate/getAllPosStyleWithRate",
    deactivateSideInMaterialRate: 'value-side-in-piece-rate/UpdateDeactivatePosStyleWithRate',
    sideInFundaRateCreate: 'value-side-in-piece-rate/saveSideInSectionWithRate',
    getAllSideInFundaRate: 'value-side-in-piece-rate/getAllSideInSectionWithRate',
    deactivateSideInFundaRate: 'value-side-in-piece-rate/UpdateDeactivateSideInSectionWithRate',

  },
  ironSide: {
    materialRateCreate: 'iron-in-piece-rate/saveIronWithRate',
    getMaterialRate: 'iron-in-piece-rate/getAllIronWithRate',
    deactivateMaterialRate: 'iron-in-piece-rate/UpdateDeactivateIronWithRate',
  },
  productionBundleTransfer: {
    productionBundleTransferSave: 'v1/prodcutionBundleTransfer'
  },
  deliveryNoteController: {
    deliveryNoteReceiveSave: 'v1/delivery-note-receive/save',
    deliveryNoteReceiveLocationId: 'v1/delivery-note-receive/buyPosID',
    deliveryNoteReceiveLocation_id: 'v1/delivery-note-receive/location_id'
  },
  productionBundleReceived: {
    productionBundleReceivedSave: 'v1/prodcutionBundleReceive/save'
  },
  manualEntry: {
    manualEntryCreateAdd: 'v1/manual-entry/Add',
    getallfundaListTypes: 'v1/manual-entry-type',
    listGetAll: 'v1/manual-entry/all',
    manualEntryGetAll: 'v1/manual-entry/allAddManualEntry',
    disableupdate: 'v1/manual-entry/Update'

  },

  CRManagement: {
    openCashRegister: 'v1/cash-register',
    closeCashRegister: 'v1/cash-register/update/{id}',
    lastOpenCashRegistry: 'v1/cash-register/open-last-cash-reg'
  },
  currencyManagement: {
    addCurrency: 'v1/currency',
    updateCurrency: 'v1/currency',
    getAllCurrency: 'v1/currency',
    getConfigureCurrency: 'v1/currency',
    currencyGetByid: 'v1/currency/get-by-id',
    getSystemCurrency: 'v1/system_settings/currency',
    setSystemCurrency: 'v1/system_settings/currency',
    currencyRateGetbyid: 'v1/currency/get-by-id'
  },
  costUpdate: {
    addCostupdate: 'v1/cost-update',
    getAllCostupdate: 'v1/cost-update',
    customGetAllCostupdate: 'v1/cost-update/custom-get-all',
    getbyidCostupdate: 'v1/cost-update',
    updateCostupdate: 'v1/cost-update/update',
    costUpdateConfigCh: 'v1/system_settings/set-cost-update-start-character',
    costUpdateConfigNum: 'v1/system_settings/set-cost-update-start-number',
    getcostUpdateConfigCh: 'v1/system_settings/get-cost-update-start-character',
    getcostUpdateConfigNum: 'v1/system_settings/get-cost-update-start-number',
    costUpdateFinalized: 'v1/cost-update/finalized',
    customCostUpdateFinalized: 'v1/cost-update/custom-get-all-by-finalized',
    costUpdatefinalizedByid: 'v1/cost-update/finalized',
    costUpdateFinalizedReport: '/v1/cost-update/finalized-report-excel',
    costUpdateFinalizedReportPDF: '/v1/cost-update/finalized-report-pdf',
    updateCostupdateLineList: 'v1/cost-update-line',
    finalCostUpdate: 'v1/cost-calculation',

    costUpdateReportList: 'v1/cost-update/items',

    costUpdateReportListReport: 'v1/cost-update/item-report',
    costUpdatePendingReport: '/v1/cost-update/pending-report-excel',
    costUpdatePendingReportPDF: '/v1/cost-update/pending-report-pdf',
  },
  reference: {
    addReference: 'v1/reference-status/add',
  },

  creditNote: {
    getPriceReturnQuantity: 'v1/credit-note/calculateTotalPrice',
    calculateTotalBreakDown: 'v1/credit-note/calculateTotalBreakDown',
    creditNoteAdd: 'v1/credit-note',
    getAllcreditNote: 'v1/credit-note',
    getAllcreditNoteNew: 'v1/credit-note/all',
    getByIDCreditNote: 'v1/credit-note',
    creditNotePdf: 'v1/credit-note/report-pdf',
  },

  corporateDiscount: {
    createCorporates: 'v1/corporate',
    getAllCorporates: 'v1/corporate',
    corporatesGetbyid: 'v1/corporate',
    updateCorporates: 'v1/corporate',
    getAllValidCorporates: 'v1/corporate/valid',

    addCorporateDiscount: 'v1/cooperate_discount',
    getAllCorporateDiscount: 'v1/cooperate_discount',

    corporateDiscountLine: 'v1/corporate-discount-line',
    corporateGetbyid: 'v1/corporate',

    addCorporateDiscountLine: 'v1/corporate-discount-line',

    getCorporatesItem: 'v1/corporate',
    getCorporatesItemRate: 'v1/corporate/rate',

    getAllCorporateDiscountSales: 'v1/cooperate_discount/get-all-corporate-discount-sales',

    // reports
    itemWiseReport: 'v1/pos/report-item-wise',
    itemWiseReportPDF: 'v1/pos/report-item-wise-pdf',
    itemGroupWise: 'v1/pos/report-item-group-wise',
    itemGroupWisePDF: 'v1/pos/report-item-batch-wise-pdf',
    corporateWiseReport: 'v1/pos/report-corporate-wise',
    corporateWiseReportPDF: 'v1/pos/report-corporate-wise-pdf',
    corporateDiscountWiseReport: 'v1/pos/report-corporate-discount-wise',
    corporateDiscountWiseReportPDF: 'v1/pos/report-corporate-discount-wise-pdf',
    corporateWiseFilter: 'v1/cooperate_discount/corporate-wise',
    discountWiseFilter: 'v1/cooperate_discount/corporate-discount-wise',
    itemBatchWiseFilter: 'v1/cooperate_discount/item-batch-wise',
    itemWiseFilter: 'v1/cooperate_discount/item-wise',
    // get all groupwise
    getAllGroupWise: 'v1/category/all',

  },
  itemCategoryWiseFieldsController: {
    getAllFieldsWise: "v1/itm-category-wise-fields/category"
  },
  itmFieldsMappingController: {
    createFieldsMapping: "v1/itm-fields-mappping",
    createFieldMapingAdd: "v1/itm-fields-mapping/add",
    updateFieldMapping: "v1/itm-fields-mapping/update",
  },
  itmFieldsTypeController: {
    createFiedlType: "v1/itm-fields-type",
    getAllFieldTypeMapping: "v1/itm-fields-type"

  }, measuremenLineTracling: {
    measuremenLineTraclingGetByPosId: 'v1/measurement-line-tracking/buyPosID'
  },
  itmFieldMasterController: {
    createFiledMasterController: 'v1/itm-fields-master-controller',
    getFiledMasterController: 'v1/itm-fields-master-controller',
    getByIdFiledMasterController: 'v1/itm-fields-master-controller',
    updatedFiledMasterController: 'v1/itm-fields-master-controller',
  }, itmFieldPressetValues: {
    createItmFieldPressetValues: 'v1/itm-fields-preset-values',
    getItmFieldPressetValues: 'v1/itm-fields-preset-values',
  },
  itmCategroyWiseFieldsController: {
    asignFieldsCategory: 'v1/itm-category-wise-fields',
    getAllAsignCategoryFields: 'v1/itm-category-wise-fields'
  }
};
